import React, {FunctionComponent} from 'react';
import styles from './SelectorBar.module.css';
import DataTypeSelector from "../data-type-selector/DataTypeSelector";
import BarChartIcon from "./bar-chart-icon.svg";
import BarChartIconDisabled from "./bar-chart-icon-disabled.svg";
import ClusterIcon from "./cluster-icon.svg";
import ClusterIconDisabled from "./cluster-icon-disabled.svg";

export type DataType = "region" | "sector" | "revenue";

interface props {
  chartTypeCB: Function;
  chartType: "cluster" | "bar";
  dataTypeCB: Function;
  dataType: DataType;
}

const SelectorBar: FunctionComponent<props> = ({
  chartTypeCB,
  chartType,
  dataTypeCB,
  dataType
}) => {
  return (
    <div className={styles.container}>
      <DataTypeSelector callbackFn={dataTypeCB} dataType={dataType}/>
      <div>
        <button
          className={`${styles.button} ${styles.clusterBarSelector}`}
          onClick={() => chartTypeCB("cluster")}
          disabled={chartType === "cluster"}
        >
          <span className={styles.noMobile}>Clusters</span>
          <span className={styles.mobile}>
            <img src={chartType === "cluster" ? ClusterIconDisabled : ClusterIcon} alt="View data as clusters"/>
          </span>
        </button>
        <button
          className={`${styles.button} ${styles.clusterBarSelector}`}
          onClick={() => chartTypeCB("bar")}
          disabled={chartType === "bar"}
        >
          <span className={styles.noMobile}>Bars</span>
          <span className={styles.mobile}>
            <img src={chartType === "bar" ? BarChartIconDisabled : BarChartIcon} alt="View data as bars" />
          </span>
        </button>
      </div>
    </div>
  );
}

export default SelectorBar;
